<nav>
  <ul>
<!--    <li><a routerLink="/promotions">Promotions</a></li>
    <li><a routerLink="/fete-des-meres">Fête des Mères</a></li>-->
    <li><a routerLink="/coffrets">Coffrets</a></li>
    <li><a routerLink="/parfums">Parfums</a></li>
    <li><a routerLink="/maquillage">Maquillage</a></li>
    <li><a routerLink="/soins">Soins</a></li>
    <li><a routerLink="/cheveux">Cheveux</a></li>
    <li><a routerLink="/bons-plans">Bons Plans</a></li>
    <li><a routerLink="/marques">Marques</a></li>
  </ul>
</nav>
